import { createAsyncThunk } from "@reduxjs/toolkit";
import { StoreState } from "../../../store/store.interface";
import { ActionStatus } from "../../../common/constants/action-status";
import { EditWishListRequest } from "../interfaces/wish-list-actions.interface";
import { editWishListApiCallMagento } from "../apis/wish-list-edit.api";

export const editWishList = createAsyncThunk('wishList/edit', async ({requestBody, wishListId}: EditWishListRequest) => {
  return editWishListApiCallMagento(requestBody, wishListId);
}, {
  condition: ((_arg, {getState} )=>{
    const state = getState() as StoreState;
    return state.wishListState.editWishList.status !== ActionStatus.loading;
  })
});